<template lang="pug">
BriqDialog(v-show="showEmailDialog" @close="$emit('close')")
  h2.mb-S Send e-mail
  BriqRadio(:options="emailTypeOptions" horizontal v-model="mailType" :disabled="isPending")
  BriqInput.mb-S(label="E-mail address" :value="customerEmail" disabled hide-optional-marker)
  BriqInput.mb-S(label="CC" v-model="cc" :disabled="isPending" @blur="$v.cc.$touch()" :error="ccError" data-test-id="send-email-cc-field")
  .actions(style="display: flex; justify-content: center;")
    BriqButton.mr-XXS(variant="text" @click="$emit('close')") Cancel
    BriqButton.ml-XXS(@click="sendEmail" :disabled="isPending || !mailType") Send e-mail
</template>

<script>
import { email } from 'vuelidate/lib/validators'
import { MailType } from '@v/bookings/details/BookingDetailsApiModel.js'
import { mapGetters } from 'vuex'

export default {
  name: 'SendEmailDialog',
  props: {
    showEmailDialog: Boolean,
  },
  data() {
    return {
      emailTypeOptions: {
        [MailType.Confirm]: 'Confirmation mail',
        [MailType.Paid]: 'Proof of payment',
      },
      mailType: MailType.Confirm,
      cc: null,
    }
  },
  validations() {
    return {
      cc: { email },
    }
  },
  computed: {
    ...mapGetters('bookingDetails', ['isPending', 'mainBooker']),
    customerEmail() {
      return this.mainBooker?.Email
    },
    ccError() {
      return (this.$v.$dirty && this.$v.cc.$invalid && 'CC needs to be valid email') || null
    },
  },
  methods: {
    sendEmail() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$notifyWarning('Validation failed, please doublecheck all fields')
        return
      }
      const sendEmailData = {
        mailType: this.mailType,
        cc: this.cc,
      }
      this.$emit('sendEmail', sendEmailData)
    },
  },
  watch: {
    showEmailDialog(newVal) {
      if (!newVal) {
        this.cc = null
        this.mailType = null
      } else {
        this.mailType = MailType.Confirm
      }
    },
  },
}
</script>

<style scoped lang="stylus">
.dialog-actions
  display flex
  justify-content center
</style>
